import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { generateWeeksForMonth, getOccupancy, getColorForOccupancy, formatDateToYMDString } from './helper';
import { formatDate } from 'src/utils/functions';
import TooltipNew from 'src/App/HOC/Tooltips/TooltipNew';

interface CalendarHeatmapProps {
  year: number;
  month: number;
  occupancyData: Record<string, number>;
}

const CalendarHeatmap: React.FC<CalendarHeatmapProps> = ({ year, month, occupancyData }) => {
  const weeks = generateWeeksForMonth(year, month);
  const currentMonthDate = new Date(year, month, 1);

  return (
    <Box>
      {/* Month and Year */}
      <Typography variant="body1" className="subHeadings" sx={{ mb: 1 }}>
        {currentMonthDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
      </Typography>

      {/* Week Header */}
      <Grid container columns={7} spacing={0.5} sx={{ mb: 0.5 }}>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(dow => (
          <Grid item xs={1} key={dow}>
            <Typography variant="body2" align="center">
              {dow}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {/* Render Each Week */}
      {weeks.map((week, wIndex) => (
        <Grid key={wIndex} container columns={7} spacing={0.5} sx={{ mb: 0.5 }}>
          {week.map((day, dIndex) => {
            const dateStr = formatDateToYMDString(day);
            const occupancyValue = getOccupancy(dateStr, occupancyData);
            const bgColor = getColorForOccupancy(occupancyValue);

            const inCurrentMonth = day.getMonth() === currentMonthDate.getMonth();
            const dayNum = inCurrentMonth ? day.getDate() : '';

            const DateBoxUi = (
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: inCurrentMonth ? bgColor : '#f7f7f7',
                  borderRadius: 1,
                  cursor: inCurrentMonth ? 'pointer' : 'default',
                }}
              >
                <Typography variant="caption" color="textPrimary">
                  {dayNum}
                </Typography>
              </Box>
            );

            return (
              <Grid item xs={1} key={dIndex}>
                {inCurrentMonth ? (
                  <TooltipNew
                    title={`${formatDate(dateStr)}`}
                    content={
                      <>
                        Occupancy Rate:{' '}
                        <span style={{ fontWeight: 'bold' }}>{occupancyValue}%</span>
                      </>
                    }
                    arrow={true}
                  >
                    {DateBoxUi}
                  </TooltipNew>
                ) : (
                  DateBoxUi
                )}
              </Grid>
            );
          })}
        </Grid>
      ))}
    </Box>
  );
};

export default CalendarHeatmap;
